import { CompanyModel } from 'api/model';

/**
 * Ankarkandidat i personalkortets hemankarväljare = de adresser en fälttestare rimligen börjar
 * och slutar dagen vid. De sorteras först i listan.
 *
 * - isCentralStation ingår sedan 2026-09-03: stationerna är defaultförslaget för fälttestare utan
 *   historik, och det som föreslås måste vara lätt att hitta i väljaren.
 * - Hubbar känns igen på kryssrutan "Är Zäkra-hub" (isZakraHub) på företagskortet, inte på namnet
 *   — samma regel som ruttplaneringen och SuggestHomeAnchors (HomeAnchorCandidates.cs). Namnet
 *   missade t.ex. " ZÄKRA HUB PITEÅ" med inledande blanksteg.
 */
const isHomeAnchorCandidate = (c: CompanyModel): boolean =>
  c.isRiddermark ||
  c.isLogisticsCenter === true ||
  c.isCentralStation === true ||
  c.isZakraHub === true;

export default isHomeAnchorCandidate;
